import React from "react";
import {
  FormikTextField,
  FormikSelectField,
  FormikCheckBoxField,
} from "../../../Common/FormFields";
import { Col } from "react-bootstrap";
import GoogleAutoComplete from "../../../Common/GoogleAutoComplete/GoogleAutoComplete";
import * as Yup from "yup";
import { validateZipCode } from "../../../VendorOnboarding/Views/Address/helpers";
import { isMerchantEmailValid } from "../../../../utils/utils";
import * as Constants from "../../../../constants/Constants";

//Exports related to Add new vendor

export const newVendorCorpName = [
  {
    name: "vendorCorpName",
    type: "text",
    length: 4,
    placeHolder: "Alfani",
    label: "Company/Legal/Billing Name",
    required: true,
    initialValue: "",
    validation: Yup.string().required(
      "The vendor corp name field is required."
    ),
  },
  {
    name: "vendorType",
    type: "select",
    length: 4,
    label: "Select Vendor Category",
    required: false,
    selectOptions: [{
      optionValue: "basicVendor",
      optionName: "Basic Vendor",
    },
    {
      optionValue: "oldVendor",
      optionName: "Old Vendor",
    }
    ]
  },
];

export const newVendorMerchantFields = [
  {
    name: "merchantFirstName",
    type: "text",
    length: 4,
    placeHolder: "John",
    label: "Merchant First Name",
    required: true,
    initialValue: "",
    validation: Yup.string()
      .required("The merchant first name field is required.")
      .test((value) => {
        const val = value.replace(/  +/g, " ");
        const regex = /^([A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u024F]?|[A-Za-z`~!@#$%^&*()=+\{\}\[\]\\|;:'",<.>//?_-\s])*$/;
        if (!regex.test(value) || val === " ") {
          return new Yup.ValidationError(
            "The merchant first name may only contain letters, space, and special characters.",
            undefined,
            "merchantFirstName"
          );
        }
        return true;
      }),
  },
  {
    name: "merchantLastName",
    type: "text",
    length: 4,
    placeHolder: "Doe",
    label: "Merchant Last Name",
    required: true,
    initialValue: "",
    validation: Yup.string()
      .required("The merchant last name field is required.")
      .test((value) => {
        const val = value.replace(/  +/g, " ");
        const regex = /^([A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u024F]?|[A-Za-z`~!@#$%^&*()=+\{\}\[\]\\|;:'",<.>//?_-\s])*$/;
        if (!regex.test(value) || val === " ") {
          return new Yup.ValidationError(
            "The merchant last name may only contain letters, space, and special characters.",
            undefined,
            "merchantLastName"
          );
        }
        return true;
      }),
  },
  {
    name: "merchantEmail",
    type: "text",
    length: 4,
    placeHolder: "john.doe@email.com",
    label: "Merchant Email",
    required: true,
    initialValue: "",
    validation: Yup.string()
      .required("The merchant email field is required.")
      .test((value) => {
        const fieldValue = value !== undefined && value?.split("@");
        const regFlag = isMerchantEmailValid(fieldValue[0]);
        const errFlag =
          fieldValue[1] === "macys.com" ||
          fieldValue[1] === "bloomingdales.com";

        if (!regFlag) {
          return new Yup.ValidationError(
            Constants.VALID_EMAIL_ERROR_MSG,
            undefined,
            "merchantEmail"
          );
        }
        if (!errFlag) {
          return new Yup.ValidationError(
            Constants.MERCHANT_EMAIL_ERROR_MSG,
            undefined,
            "merchantEmail"
          );
        }
        return true;
      }),
  },
];

export const newVendorAddressFields = [
  {
    name: "streetAddress",
    label: "Mailing Address Street Name",
    required: true,
    length: 4,
    placeHolder: "151 W 34th street",
    automationId: `mailingAddress`,
    key: `streetAddress_${"mailing"}${"0"}`,
    type: "googleText",
    initialValue: "",
    validation: Yup.string().required("The street address field is required."),
  },
  {
    name: "suiteUnitFloor",
    label: "Unit",
    length: 1,
    required: false,
    placeHolder: "11",
    type: "text",
    initialValue: "",
    validation: Yup.string(),
  },
  {
    name: "city",
    label: "City",
    length: 2,
    required: true,
    placeHolder: "New York",
    type: "text",
    initialValue: "",
    validation: Yup.string()
      .required("The city field is required.")
      .test((value) => {
        const regex = /^[a-zA-Z\s]*$/;
        if (!regex.test(value)) {
          return new Yup.ValidationError(
            "This may contain only letter and spaces",
            undefined,
            "city"
          );
        }
        return true;
      }),
  },
  {
    name: "state",
    label: "State/Province",
    length: 2,
    maxLength: 2,
    required: true,
    placeHolder: "NY",
    type: "text",
    initialValue: "",
    validation: Yup.string()
      .required("The state field is required.")
      .min(2, "This should be 2 characters long")
      .test((value) => {
        const regex = /^[a-zA-Z]*$/;
        if (!regex.test(value)) {
          return new Yup.ValidationError(
            "This may contain only letter",
            undefined,
            "state"
          );
        }
        return true;
      }),
  },
  {
    name: "postalCode",
    label: "Zip",
    length: 2,
    required: true,
    placeHolder: "10001",
    type: "text",
    initialValue: "",
    validation: Yup.string()
      .required("The Zip field is required")
      .test((value) => {
        if (!validateZipCode(value)) {
          return new Yup.ValidationError(
            "e.g 10001, 10001-9999, A1A 1A1, A1A1A1",
            undefined,
            "postalCode"
          );
        }
        return true;
      }),
  },
  {
    name: "country",
    label: "Country",
    required: true,
    length: 1,
    maxLength: 2,
    type: "text",
    placeHolder: "US",
    initialValue: "",
    validation: Yup.string()
      .required("The country field is required.")
      .min(2, "This should be atleast 2 characters long")
      .test((value) => {
        const regex = /^[a-zA-Z]*$/;
        if (!regex.test(value)) {
          return new Yup.ValidationError(
            "This may contain only letter",
            undefined,
            "country"
          );
        }
        return true;
      }),
  },
];

export const newVendorContactFields = [
  {
    name: "firstName",
    label: "Primary Contact First Name",
    type: "text",
    required: true,
    length: 3,
    placeHolder: "Terrence",
    initialValue: "",
    validation: Yup.string()
      .required("The first name field is required.")
      .test((value) => {
        const val = value.replace(/  +/g, " ");
        const regex = /^([A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u024F]?|[A-Za-z`~!@#$%^&*()=+\{\}\[\]\\|;:'",<.>//?_-\s])*$/;
        if (!regex.test(value) || val === " ") {
          return new Yup.ValidationError(
            "The first name may only contain letters, space, and special characters.",
            undefined,
            "firstName"
          );
        }
        return true;
      }),
  },
  {
    name: "lastName",
    label: "Last Name",
    type: "text",
    required: true,
    length: 3,
    placeHolder: "Buick",
    initialValue: "",
    validation: Yup.string()
      .required("The last name field is required.")
      .test((value) => {
        const val = value.replace(/  +/g, " ");
        const regex = /^([A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u024F]?|[A-Za-z`~!@#$%^&*()=+\{\}\[\]\\|;:'",<.>//?_-\s])*$/;
        if (!regex.test(value) || val === " ") {
          return new Yup.ValidationError(
            "The last name may only contain letters, space, and special characters.",
            undefined,
            "lastName"
          );
        }
        return true;
      }),
  },
  {
    name: "corpEmailId",
    label: "Email",
    required: true,
    length: 3,
    type: "text",
    placeHolder: "john.doe@email.com",
    initialValue: "",
    validation: Yup.string()
      .email("Invalid email")
      .required("The corp email id field is required."),
  },
  {
    name: "phoneNumber",
    label: "Phone Number",
    required: true,
    length: 2,
    maxLength: 10,
    type: "text",
    placeHolder: "4046985958",
    initialValue: "",
    validation: Yup.string()
      .required("The phone number field is required.")
      .min(10, "This be 10 character long"),
  },
  {
    name: "extension",
    label: "Extension",
    type: "text",
    placeHolder: "5658",
    required: false,
    maxLength: 5,
    length: 1,
    initialValue: "",
    validation: Yup.number().typeError("Extension must be a number"),
  },
];

export const getFormFields = (
  formConfigList,
  setFieldValue = null,
  values,
  setAddressError,
  addressError,
  ext = null,
  ...remains
) => {
  let fieldList = [];
  formConfigList.forEach(({ validation, ...rest }) => {
    //destructured out the validation property because we do not want to pass that to native input control
    //Passing a type property to input control is mandatory otherwise the placeholder will be darker in color
    if (rest.type === "text") {
      fieldList.push(<FormikTextField {...rest} />);
    }
    if (rest.type === "select") {
      fieldList.push(<FormikSelectField as="select" {...rest} />);
    }
    if (rest.type === "googleText") {
      rest.setFieldValue = setFieldValue;
      rest.setAddressError = setAddressError;
      rest.addressError = addressError;
      rest.values = values;
      rest.remains = remains;
      rest.ext = ext;
      fieldList.push(googleTextField(rest));
    }
    if (rest.type === "checkbox") {
      fieldList.push(<FormikCheckBoxField {...rest} />);
    }
  });

  return fieldList;
};
const field = {
  fieldId: `streetAddress`,
  fieldLabel: "Mailing Address Street Name",
  required: true,
  length: 4,
  placeHolder: "151 W 34th street",
  fieldType: "text",
  automationId: `Mail Address`,
  key: `streetAddress`,
};
const onAutoCompleteChange = (e, setFieldValue) => {
  setFieldValue("streetAddress", e.target.value, true);
};
const onSelectAddress = (e, setFieldValue) => {
  setFieldValue("streetAddress", e.streetAddress, true);
  setFieldValue("country", e.country, true);
  setFieldValue("city", e.city, true);
  setFieldValue("streetAddress", e.streetAddress, true);
  setFieldValue("postalCode", e.zipCode, true);
  setFieldValue("state", e.state, true);
};
export const validationSchema = Yup.object({
  streetAddress: Yup.string().required("The street address field is required."),
});
const handleValidate = (fieldInfo, setFormValues, setAddressError) => {
  const { field, fieldValue } = fieldInfo;
  Yup.reach(validationSchema, `${[field.fieldId]}`)
    .validate(fieldValue)
    .then((value) => {
      setAddressError("");
    })
    .catch((err) => {
      setAddressError(err.message);
      setFormValues((state) => ({
        ...state,
        errors: {
          ...state.errors,
          [field.key]: err.message,
        },
      }));
    });
};
export const googleTextField = (props) => {
  const obj = {};
  const key = field.key;
  if (props.ext) {
    field.length = 9;
  }
  obj["streetAddress"] = props.addressError;
  return (
    <Col
      xs={field.length || 12}
      style={{
        padding: 0,
        margin: (props.addressFields ? 0 : "5px 0 0 0") || 0,
      }}
    >
      <GoogleAutoComplete
        handleValidate={(e) => {
          handleValidate(e, props.setFieldValue, props.setAddressError);
        }}
        errors={obj}
        field={field}
        isExt={props.ext}
        uniqueKey={"key"}
        value={props?.values?.streetAddress || ""}
        onAutoCompleteChange={(e) => {
          onAutoCompleteChange(e, props.setFieldValue);
        }}
        onSelectAddress={(e) => {
          onSelectAddress(e, props.setFieldValue);
        }}
        addressFields={props?.field}
        addressIndex={"1"}
      />
    </Col>
  );
};

export const getInitialFormValues = (list) => {
  let initialFormValues = {};
  if (list && list.length > 0) {
    list.forEach((item) => {
      initialFormValues[item.name] = item.initialValue || "";
    });
  }
  return initialFormValues;
};

export const getFormValidations = (list) => {
  let validations = {};
  if (list && list.length > 0) {
    list.forEach((item) => {
      if (item.validation) {
        validations[item.name] = item.validation;
      }
    });
  }
  return Yup.object().shape({ ...validations });
};

//Exports related to Add existing vendor

export const validatedDunsConnectionFields = [
  {
    name: "merchandiseType",
    type: "select",
    length: 6,
    label: "Vendor Fulfillment Type",
    required: true,
    initialValue: "",
    validation: Yup.string().required(
      "The vendor fulfillment type is required."
    ),
    selectOptions: [
      {
        optionValue: "VDF",
        optionName: "Vendor Direct Fulfillment",
      },
      {
        optionValue: "Owned Inventory",
        optionName: "Traditional Vendor",
      },
    ],
    ["data-testid"]: "addExistingVendor_form_connection_select_merchandiseType",
  },
  {
    name: "vendorConnectionPlatform",
    type: "select",
    length: 6,
    label: "Vendor Connection",
    required: true,
    initialValue: "",
    validation: Yup.string().required("The vendor connection is required."),
    selectOptions: [
      {
        optionValue: "chub",
        optionName: "Commerce Hub",
      },
      {
        optionValue: "directEdi",
        optionName: "Direct EDI",
      },
      {
        optionValue: "directEdiRDS",
        optionName: "Direct EDI RDS",
      },
    ],
    ["data-testid"]:
      "addExistingVendor_form_connection_select_vendorConnectionPlatform",
  },
];

export const formatPhone = (phoneNumber) => {
  if (phoneNumber.replace(/\D/g, "").length === 10) {
    let temp = phoneNumber
      .replace("(", "")
      .replace(")", "")
      .replace("-", "");
    let pn =
      "(" + temp.slice(0, 3) + ") " + temp.slice(3, 6) + "-" + temp.slice(6);

    return pn === "()-" ? "" : pn;
  } else {
    return phoneNumber.replace(/\D/g, "");
  }
};
